import { render } from "./OrderMessages.vue?vue&type=template&id=2603fbd5"
import script from "./OrderMessages.vue?vue&type=script&lang=js"
export * from "./OrderMessages.vue?vue&type=script&lang=js"

import "./OrderMessages.vue?vue&type=style&index=0&id=2603fbd5&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\projects\\external\\kazigraphix\\admin.kazigraphix\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__